import { DecimalPipe, NgIf } from '@angular/common';
import { Component, inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormsModule, NgModel, ValidationErrors } from '@angular/forms';
import { MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatCell, MatCellDef, MatColumnDef, MatFooterCell, MatFooterCellDef, MatFooterRow, MatFooterRowDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { InventarItem } from '@gsm/entities';
import { WINDOW } from 'ngx-window-token';
import { filterEmptyProps } from '../../helpers/filter-props.helper';
import { AlphanumValidator } from '../../validators/alphanum.validator';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { InventaraufstellungTableModel } from './inventaraufstellung-table.model';

@Component({
  selector:    'gsm-inventaraufstellung-table',
  templateUrl: './inventaraufstellung-table.component.html',
  styleUrls:   ['./inventaraufstellung-table.component.scss'],
  standalone:  true,
  imports:     [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatInput,
    FormsModule,
    AlphanumValidator,
    MatFooterCellDef,
    MatFooterCell,
    NgIf,
    MatIconButton,
    MatIcon,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    MatMiniFabButton,
    DecimalPipe
  ]
})
export class InventaraufstellungTableComponent extends CustomDynamicFormControlComponent<InventaraufstellungTableModel> implements OnInit {
  private window = inject<Window>(WINDOW);

  numberPattern = '^(0|[1-9][0-9]*)$';
  displayedColumns: string[] = [
    'art',
    'bezeichnung',
    'anzahl',
    'betrag',
    'delete'
  ];
  itemList = new MatTableDataSource<InventarItem>();

  private _requiredFields = [
    'art',
    'summe'
  ];

  @ViewChildren('art') artModels: QueryList<NgModel>;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onModelChange() {
    if (!this.model.value || !this.model.value.positionen || !this.model.value.positionen.length) {
      this.itemList.data = [];
      this.addItem();
    } else {
      this.itemList.data = this.model.value.positionen;
    }
    this.window.setTimeout(() => {
      this._emitChange();
    }, 0);
  }

  get totalSum(): number {
    return this.itemList.data.reduce((total, item) => {
      const summe = item.summe || 0;
      return total + summe;
    }, 0);
  }

  addItem() {
    const newElItem: InventarItem = {
      art:         null,
      bezeichnung: null,
      anzahl:      null,
      summe:       null
    };
    const data = this.itemList.data;
    data.push(newElItem);
    this.itemList.data = data;
    this.onFormValueChange();
  }

  deleteItem(index: number) {
    if (this.itemList.data.length > 1) {
      const data = this.itemList.data;
      data.splice(index, 1);
      this.itemList.data = data;
      this.onFormValueChange();
    } else if (index === 0) {
      this.resetItem(this.itemList.data[0]);
    }
  }

  onInputBlur() {
    this.onFormValueChange();
  }

  onFormValueChange() {
    this.model.value = {
      positionen: this.itemList.data.map(item => filterEmptyProps(item)),
      summe:      this.totalSum
    };
    this._markRequiredFieldsTouched();
    this._emitChange();
  }

  private _markRequiredFieldsTouched() {
    if (this.artModels) {
      this.artModels.forEach(mod => mod.control.markAsTouched());
    }
  }

  resetItem(item: InventarItem) {
    item.anzahl = null;
    item.art = null;
    item.bezeichnung = null;
    item.summe = null;
    this.onFormValueChange();
  }

  private _emitChange() {
    this.group.get(this.model.id)
      .setErrors(this._getErrors());
    this.change.emit(this.model.value);
  }

  private _getErrors(): ValidationErrors {
    const invalid = this.totalSum <= 0 || this.itemList.data.some(item => item && this._requiredFields.some(field => !item[field]));
    return invalid ? {eigenleistungAufstellung: true} : null;
  }
}
